declare namespace $ {

	export class $mol_icon_align_vertical_top extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=top.view.tree.d.ts.map